import React from 'react'
import NavbarContainer from '../components/NavbarContainer/NavbarContainer'
import Footer from '../components/Footer/Footer'
import CommonHeader from '../components/CommonHeader/CommonHeader'
import ContactusForm from '../components/ContactusForm/ContactusForm'
import ContactusInfo from '../components/ContactusInfo/ContactusInfo'
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';

function Contactus() {
        const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div>
      <NavbarContainer/>
      <CommonHeader
      title={currentLocal.home.reachUs}
      />
      <Container>
        <Row>
          {/* <Col md={6}>
          <ContactusForm/>
          </Col> */}
                    <Col md={4}>
</Col>

          <Col md={4}>
          <ContactusInfo/>
          </Col>
                    <Col md={4}>
</Col>
        </Row>
      </Container>
      <Footer/>
    </div>
  )
}

export default Contactus